import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { setUIState, containerIds } from 'modules/ui'
import { companyFragment, viewerFragment, userErrorsFragment } from 'fragments'
import BusinessLayout from 'components/layouts/BusinessLayout/signup'
import queryString from 'query-string'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import Path from 'routes/path'

function RequestToJoinContainer(props) {
  const { data, location } = props
  const company = data.company

  async function onClick(e) {
    e.preventDefault()
    const href = e.target.href
    const { ui, data, requestToJoinCompany } = props
    const company = data.company
    const currentUser = data.viewer
    if (currentUser) {
      try {
        const res = await requestToJoinCompany({
          companyUsername: company.username,
        })

        if (res.data.requestToJoinCompany.userErrors.length) {
          console.log('failed!')
        } else {
          console.log('success')
          redirectTo(`${href}?done=1`)
        }
      } catch (error) {
        console.log(error.graphQLErrors)
      } finally {
        console.log('finally')
      }
    }
  }

  function renderDone() {
    const { data } = props
    const company = data.company

    return (
      <div className="page__col1">
        <div className="signup-head">
          <h1 className="page-title">
            {i18n.t('page.request_to_join.l_00005')}
          </h1>
          <ul className="signup-step signup-step2 mb20">
            <li className="signup-step__status1">
              {i18n.t('page.request_to_join.l_00002')}
            </li>
            <li className="signup-step__status3 is-current">
              {i18n.t('page.request_to_join.l_00003')}
            </li>
          </ul>
        </div>
        <div className="signup-box">
          <div className="row">
            <div className="col-xs-12">
              <div className="signup-box__wrapper">
                <p className="signup-box__notes ta-c">
                  {i18n.t('page.request_to_join.l_00006', {
                    name: company.name,
                  })}
                  <br />
                  {i18n.t('page.request_to_join.l_00007')}
                </p>
                <div className="col-xs-12 ta-c mt20">
                  <a
                    href={wwwUrl('/search')}
                    className="button-green pt15 pb15 w200 sm-w100"
                  >
                    {i18n.t('page.shared.l_00070')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderForm() {
    const { data, config } = props
    const currentUser = data.viewer
    const company = data.company

    return (
      <div className="page__col1">
        <div className="signup-head">
          <h1 className="page-title">
            {i18n.t('page.request_to_join.l_00001')}
          </h1>
          <ul className="signup-step signup-step2 mb20">
            <li className="signup-step__status1 is-current">
              {i18n.t('page.request_to_join.l_00002')}
            </li>
            <li className="signup-step__status3">
              {i18n.t('page.request_to_join.l_00003')}
            </li>
          </ul>
        </div>
        {!currentUser ? (
          <p className="signup-welcome business-signup__text">
            {i18n.t('page.join.l_00002')}
            <a
              href={Path.loginAccount(config.URL || '')}
              className="business-link"
            >
              {i18n.t('page.shared.l_00015')}
            </a>
            {i18n.t('page.join.l_00003')}
            <br />
            {i18n.t('page.join.l_00004')}
            <a
              href={Path.signupAccount(config.URL || '')}
              className="business-link"
            >
              {i18n.t('page.shared.l_00017')}
            </a>
            {i18n.t('page.join.l_00005')}
          </p>
        ) : (
          <div className="signup-box">
            <div className="row">
              <div className="col-xs-12">
                <div className="signup-box__wrapper">
                  <p className="signup-box__notes ta-c">
                    {i18n.t('page.request_to_join.l_00004', {
                      name: company.name,
                    })}
                  </p>
                </div>
              </div>
              <div className="col-xs-12 ta-c mt20">
                <a
                  href={`/companies/${company.username}/request_to_join`}
                  onClick={onClick}
                  className="button-green pt15 pb15 w200 sm-w100"
                >
                  {i18n.t('page.request_to_join.l_00002')}
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  const done = queryString.parse(location.search).done
  return (
    <BusinessLayout
      title={i18n.t('server.business.request_to_join.title', {
        name: company.name,
      })}
      description={i18n.t('server.business.request_to_join.description', {
        name: company.name,
      })}
      {...props}
    >
      <div className="site-main">
        <div className="lp-page__padding">
          {done ? renderDone() : renderForm()}
        </div>
      </div>
    </BusinessLayout>
  )
}

const requestToJoinCompany = gql`
  mutation requestToJoinCompany($input: RequestToJoinCompanyInput!) {
    requestToJoinCompany(input: $input) {
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const withMutation = graphql(requestToJoinCompany, {
  props: ({ mutate }) => ({
    requestToJoinCompany: input => mutate({ variables: { input } }),
  }),
})(RequestToJoinContainer)

const withData = graphql(
  gql`
  query BusinessRequestToJoinContainer($username: String!) {
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
    company(username: $username) {
      name
      username
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
      },
    }),
  },
)(withMutation)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return {
    actions: bindActionCreators(bindActions, dispatch, requestToJoinCompany),
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)
